import(/* webpackMode: "eager" */ "C:\\Users\\62877\\Documents\\NAYVERA\\src\\app\\tentang-kami-page\\page.tsx");
